import { styled, FormControl, formControlLabelClasses, radioClasses, svgIconClasses } from "@mui/material";
const RadioFormControl = styled(FormControl)(({ error, theme }) => ({
  [`& .${formControlLabelClasses.root}`]: {
    width: "100%"
  },
  [`& .${formControlLabelClasses.label}`]: {
    color: error ? theme.palette.error[500] : theme.palette.grey[800]
  },
  [`& .${radioClasses.root} .${svgIconClasses.root}`]: {
    color: error ? theme.palette.error[500] : "currentColor"
  }
}));
export {
  RadioFormControl
};
